/**
 * oa模块接口配置
 */
const oaApi = {
  // 平台管理列表查询
  platformList: 'oa/license/platform/search',
  // 新增修改平台
  platformSave: 'oa/license/platform/save',
  // 验证用户登录密码
  checkUser: 'oa/license/platform/platform/checkUser',
  // 平台单个删除
  platformDel: 'oa/license/platform/del',
  // 获取所有证照类型
  getAllCertificateType: 'oa/license/certificateType/getAll',
  // 添加证照类型
  addCertificateType: 'oa/license/certificateType/add',
  // 删除证照类型
  deleteCertificateType: 'oa/license/certificateType/delete/',
  // 证照管理列表获取
  certificates: 'oa/license/certificate/search',
  // 新增证照
  addCertificate: 'oa/license/certificate/add',
  // 获取id
  getCommonId: 'common/id',
  // 证照根据所属人动态检索
  getOwnersBy: 'oa/license/certificate/owners/by',
  // 证照管理更新续期
  certificateRenewal: 'oa/license/certificate/renewal',
  // 证照管理根据id删除
  delId: 'oa/license/certificate/del',
  // 证照管理批量删除
  licenseDelAll: 'oa/license/certificate/delAll',
  // 证照管理查询一条数据
  certificateFindById: 'oa/license/certificate/find',
  // 更新证照信息
  certificateUpdate: 'oa/license/certificate/update',
  // 更新关联平台
  updatePlatform: 'oa/license/certificate/update/correlate_platform',
  // 预约记录查询
  certificateApplys: 'oa/license/certificateApply/list',
  // 保存提交预约记录
  certificateApplySave: 'oa/license/certificateApply/save',
  // 证书使用申请删除
  certificateApplyDel: 'oa/license/certificateApply/del',
  // 获取单个使用申请详情
  certificateApplyFind: 'oa/license/certificateApply/findById',
  // 证书即将到期列表
  certificateExpire: 'oa/license/certificate/expire',
  // 证书到期提醒
  certificateRemind: 'oa/license/certificate/remind/save',
  // 使用申请更改状态
  certificateApplyOperate: 'oa/license/certificateApply/process',
  // 添加转出记录
  certificateOutAdd: 'oa/license/certificateOut/add',
  // 证照预约记录
  certificateApplies: 'oa/license/certificateApply/applies',
  // 报销相关
  reimbursement: 'oa/reimbursement',
  // 报销职位标准
  jobStandard: 'oa/reimbursement/jobStandard',
  // 报销地区标准
  regionStandard: 'oa/reimbursement/regionStandard',
  // 报销默认标准
  defaultStandard: 'oa/reimbursement/defaultStandard',
  // 考勤记录相关
  attendanceRecord: 'oa/attendance/attendanceRecord',
  // 出差申请相关
  businessTripApply: 'oa/reimbursement/businessTripApply',
  // 用车报销相关
  carExpense: 'oa/reimbursement/carExpense',
  // 差旅报销相关
  businessTripExpense: 'oa/reimbursement/businessTripExpense',
  // 付款相关
  pay: 'oa/reimbursement/payApply',
  // 快递费报销相关
  deliveryExpense: 'oa/reimbursement/deliveryExpense',
  // 通用报销相关
  commonExpense: 'oa/reimbursement/commonExpense',
  // 出差补助相关
  businessTripSubsidy: 'oa/reimbursement/businessTripSubsidy',
  // 印章使用相关
  chapterManager: 'oa/chapter/chapterManager',
  // 报销管理打印
  printActivity: 'oa/reimbursement/printActivity/list',
  // 报备管理
  filing: 'ws/filing',
  // 防伪验证提交信息
  getReportDeatails: 'ws/biz/bizReport/getReportDeatails',
  // 获取项目状态
  bizProjectStatus: 'ws/biz/bizProject/status',
  // 项目归档流程
  findOneByArchiveId: '/ws/biz/findOneByArchiveId',
  // 获取审批按钮状态
  processCanApprove: '/ws/process/canApprove',
  // 报销管理获取牌照信息
  licenseAll: '/ws/system/license/getAll',
  // 资金申请
  payApply: 'oa/reimbursement/payApply/fund',
  // 招待申请
  businessServerApply: 'oa/reimbursement/businessServerApply',
  // 用车申请
  carApply: 'oa/reimbursement/carApply',
  // 加班餐费申请
  overtimeReimbursement: '/oa/reimbursement/overtime',
  // 资金审批一览
  reimbursementfund: 'oa/reimbursement/fund/apply',
  // 费用报销
  feeReimbursement: 'oa/reimbursement/fee/list',
  // 费用报销删除
  feeReimbursementDelete: 'oa/reimbursement/fee/delete',
  // 市场费报销
  marketExpense: 'oa/reimbursement/market/expense',
  // 其他费用报销
  genexalExpense: 'oa/reimbursement/general/expense',
  // 招待费报销
  businessServerExpense: 'oa/reimbursement/businessServerExpense',
  // 司机报销
  driver: 'oa/reimbursement/driver/expense/',
  // 招标费申请
  tenderApply: 'oa/reimbursement/tenderApply/',
  // 招标费报销
  inTenderExpense: '/oa/reimbursement/inTender/expense/',
  // 私车公用报销
  carApplyExpense: 'oa/reimbursement/carApplyExpense',
  // 获取评估对象
  findTreeByCode: 'ws/system/multiDict/findTreeByCode',
  // 导出评估合同
  exportAccessContract: '/ws/api/biz/bizProject/exportAccessContract',
  // 导出评估报告
  exportAccessData: '/ws/api/biz/bizProject/exportAccessData',
  // 下载评估合同
  downloadAccessContract: '/ws/api/biz/bizProject/downloadAccessContract',
  // 下载评估报告
  downloadAccessReport: '/ws/api/biz/bizProject/downloadAccessReport',
  // 导出审计报告
  exportAuditData: '/ws/api/biz/bizProject/exportAuditData',
  // 导出年报审计报告
  exportAnnualReportData: '/ws/api/biz/bizProject/exportAnnualReportData',
  // 查询可用的牌照信息
  findByUserCompany: '/ws/system/license/findByUserCompany',
  // 查询核算负责人
  getAccountingManager: '/ws/system/getAccountingManager/',
  // 投标项目导出所有数据
  tenderProExportAll: '/ws/tender/project/api/exportAll',
  // 奖金核算
  bonusAccount: 'ws/bonus/info',
  // 获取部门
  organization: '/ws/system/organization',
  // 根据姓名模糊搜索（该部门下用户
  searchSubByUserName: '/ws/system/user/searchSubByUserName',
  // 作业信息
  personalProject: 'ws/biz/personal/project',
  // 获取数据字典层级结构数据（包含父节点）
  findTreeByCodeHasParent: 'ws/system/multiDict/findTreeByCodeHasParent',
  // 删除文件接口
  delFile: '/ws/api/delFile/',
  // 获取文件管理列表
  selectProjectFileList: '/ws/biz/file/selectProjectFileList',
  // 获取归档文件路径
  copyUrl: '/ws/biz/file/copyUrl'
}
var api = {
  // 客户评价链接
  // evaluateApi:''
  // 图片地址：单文件上传
  imgsPath: '/ws/api/file/upload',
  // 登录接口
  loginApi: '/ws/api/login',
  // 退出接口
  logoutApi: '/ws/api/logout',
  // 用户接口
  userApi: '/ws/system/user',
  // 用户接口(业务查询)
  userBusinessApi: '/ws/system',
  // 角色接口
  roleApi: '/ws/system/role',
  // 岗位接口
  positionApi: '/ws/system/position',
  // 权限接口
  permissionApi: '/ws/system/permission',
  // 部门接口
  departmentApi: '/ws/system/department',
  // 公司接口
  companyApi: '/ws/system/company',
  // 牌照接口
  licenseApi: '/ws/system/license',
  // 数据字典接口
  dataDictApi: '/ws/api/system/dataDict',
  // 流水号规则条目类型接口
  snRuleItemTypeApi: '/ws/system/snRuleItemType',
  // 流水号规则条目接口
  snRuleItemApi: '/ws/system/snRuleItem',
  // 流水号规则详情接口
  snRuleDetailApi: '/ws/system/snRuleDetail',
  // 流水号规则接口
  snRuleApi: '/ws/system/snRule',
  // 流水号记录接口
  snApi: '/ws/system/sn',
  // 流程接口
  processApi: '/ws/activiti/process',
  // 流程实例接口
  processInstanceApi: '/ws/activiti/processInstance',
  // 工作流-待办接口
  workflowTodoTaskApi: '/ws/workflow/task/todo',
  // 工作流-已办接口
  workflowDoneTaskApi: '/ws/workflow/task/done',
  // 工作流-流程历史信息接口
  workflowHistoryTaskApi: '/ws/workflow/task/history',
  // 客户商务沟通
  customerActivityApi: '/ws/customer/customerActivity',
  // 客户商务沟通记录
  customerActivityRecordApi: '/ws/customer/customerActivityRecord',
  // 客户接口
  customerApi: '/ws/customer',
  // 客户联系人接口
  customerListLinkMan: '/ws/customerLinkman',
  // 客户接口-根据客户企业全称模糊匹配客户
  customerApiSearchByFullName: '/ws/customer/searchByFullName',
  // 评估被评估单位接口
  SearchAssessCustomer: '/ws/assessCustomer/findByName',
  // 客户接口-根据客户企业全称模糊匹配客户
  customerApiCheckHasSign: '/ws/customer/checkHasSign',
  // 用户接口-根据姓名模糊匹配用户
  userApiSearchByUserName: '/ws/system/user/searchByUserName',
  userApiImportExcel: '/ws/system/user/importExcel',

  // 查询用户的所有信息
  findOneUser: '/ws/system/findOneUser',
  // 部门管理中添加查询树
  findByCompanyId: '/ws/system/department/findByCompanyId',
  // 会议室数据
  resourcesRoom: '/ws/resources/resourcesRoom',
  // 预约会议室人员
  findAllUser: '/ws/resources/findAllUser',
  // 新增会议室预约,撤回
  resourcesRoomOrderBack: '/ws/resources',
  // 导出预约记录
  exportMeetingOrder: '/ws/resources/exportMeetingOrder',
  // 新增会议室预约,列表（查自己）
  resourcesRoomOrder: '/ws/resources/resourcesRoomOrder',
  // 新增会议室预约,列表（行政，admin查全部）
  resourcesRoomOrderAll: '/ws/resources/resourcesRoomOrderAll',
  // 车辆信息
  car: '/ws/resources/car',
  // 车辆预约信息
  carOrder: '/ws/resources/carOrder',
  // 投标公告api
  tenderAnnouncementApi: '/ws/tender/announcement/api',
  // 投标公告列表全部
  tenderNoticeListAll: '/ws/tender/announcement/api/getListAll',
  // 投标公告列表分页
  tenderNoticeList: '/ws/tender/announcement/api/getList',
  // 投标公告详情
  tenderNoticeDetails: '/ws/tender/announcement/api/findById',
  // 投标公告详情
  tenderNoticeAdd: '/ws/tender/project/api/insertProject',
  // 投标项目
  tenderProjectApi: '/ws/tender/project/api',
  // 投标项目列表分页
  tenderNoticeCompany: '/ws/tender/project/api/getList',
  // 投标项目列表全部
  tenderNoticeCompanyAll: '/ws/tender/project/api/getListAll',
  // 投标项目详情
  tenderProjectDetail: '/ws/tender/project/api/findById',
  // 缴纳投标保证金
  tenderBailApi: '/ws/tender/bail/api',
  // 缴纳投标保证金
  tenderBailInsertBail: '/ws/tender/bail/api/insertBail',
  // 缴纳投标保证金详情
  tenderBaildetail: '/ws/tender/bail/api/findById',
  // 会议室管理接口
  resourcesRoomApi: '/ws/resources',
  // 标书制作
  tenderMakingApi: '/ws/tender/making/api',
  // 标书制作新增
  insertMakingAdd: '/ws/tender/making/api/insertMaking',
  // 标书制作新增
  insertMakingDetail: '/ws/tender/making/api/findById',
  // 应标信息
  bidInfoApi: '/ws/tender/bidInfo/api',
  // 应标信息收集
  insertBidInfoAdd: '/ws/tender/bidInfo/api/insertBidInfo',
  // 应标信息客户端详情
  bidInfoFindById: '/ws/tender/bidInfo/api/findById',

  // 其他信息
  tenderBidExtraApi: '/ws/tender/bidExtra/api',
  // 其他信息收集
  insertBidExtraAdd: '/ws/tender/bidInfo/api/insertBidExtra',
  // 其它信息列表查询
  insertBidExtraAddfindList: 'ws/tender/bidExtra/api/getBidExtraByBidIdList',
  // 投标结果
  resultInfoApi: 'ws/tender/resultInfo/api',
  // 获取投标结果
  insertResultInfoAdd: 'ws/tender/resultInfo/api/insertResultInfo',
  // 获取投标结果列表信息
  getResultInfoLis: 'ws/tender/resultInfo/api/getResultInfoLis',
  // 获取投标结果 其它信息
  getResultExtraLis: 'ws/tender/resultExtra/api/getListById',
  // 获取投标结果   其它信息新增
  insertTenderResultExtra: 'ws/tender/resultExtra/api/insertTenderResultExtra',
  // 获取投标结果其他操作
  resultExtra: 'ws/tender/resultExtra/api',
  // 中标服务费
  tenderServiceChargeApi: 'ws/tender/serviceCharge/api',
  // 缴纳中标服务费
  insertServiceChargeAdd: 'ws/tender/serviceCharge/api/insertServiceCharge',
  serviceChargeDetail: 'ws/tender/serviceCharge/api/findById',
  // 领取中标通知书
  tenderNoticeApi: 'ws/tender/notice/api',
  insertNoticeAdd: 'ws/tender/notice/api/insertNotice',
  noticeDetail: 'ws/tender/notice/api/findById',
  // 签订合同
  tenderContractApi: 'ws/tender/Contract/api',
  insertContractAdd: 'ws/tender/Contract/api/insertContract',
  contractDetail: 'ws/tender/Contract/api/findById',
  // 开中标服务发票
  tenderInvoiceApi: 'ws/tender/invoice/api',
  inserInvoiceAdd: 'ws/tender/invoice/api/inserInvoice',
  invoiceDetail: 'ws/tender/invoice/api/findById',
  // 新增退保手续
  tenderSurrenderApi: 'ws/tender/surrender/api',
  insertSurrenderAdd: 'ws/tender/surrender/api/insertSurrender',
  surrenderDetail: 'ws/tender/surrender/api/findById',
  // 文件上传的地址
  commonUpload: 'ws/api/commonUpload',
  // 32位随机码
  getUUID: '/ws/api/getUUID',
  // 投标项目删除
  projectBatchDelete: '/ws/tender/project/api/updateProject',
  // 投标项目终止
  projectEnd: '/ws/tender/project/api/end',
  // 查询附件列表
  detailFileList: '/ws/api/getFileList',
  // 用户操作列表：
  searchByUserName: '/ws/system/user/searchByUserName',
  userName: '/ws/system/user',
  /* 根据公司id查询名称 */
  companyName: 'ws/system/company',
  /* 代办中心 */
  findMsgreciList: '/ws/tender/msgreciList/api/findMsgreciList',
  // 合同接口
  contractApi: '/ws/biz/bizContract',
  // 发票接口
  invoiceApi: '/ws/biz/bizInvoice',
  // 发票导出
  invoiceExportApi: '/ws/biz/bizInvoice/export',
  abolishInvoice: '/ws/biz/bizInvoice/abolishInvoice',
  // 根据付款单位查询发票接口
  invoiceFindByIncomeApi: '/ws/biz/bizInvoice/findByIncome',
  // 发票接口-开票
  invoiceOpenTicketApi: '/ws/biz/bizInvoice/openTicket',
  // 发票接口-领票
  invoiceTakeTicketApi: '/ws/biz/bizInvoice/takeTicket',
  // 业务来源
  busiSource: '/ws/biz/bizBusinessSource',
  // 业务管理-项目接口
  bizProjectApi: '/ws/biz/bizProject',
  // 业务管理-项目接口
  bizProjectTraceApi: '/ws/biz/bizProjectTrace',
  // 业务管理-投标项目项目接口
  tenderBizProjectApi: '/ws/tender/project/api/bizProject',
  // 业务管理-项目类型接口
  bizProjectTypeApi: '/ws/biz/bizProjectType',
  // 业务管理-项目团队接口
  bizProjectTeamApi: '/ws/biz/bizProjectTeam',
  // 业务管理-项目团队角色接口
  bizProjectTeamRoleApi: '/ws/biz/bizProjectTeamRole',
  // 业务管理-项目签章接口
  bizProjectStampRecordApi: '/ws/biz/bizProjectStampRecord',
  // 业务管理-报告接口
  bizReport: '/ws/biz/bizReport',
  // 业务管理-报告类型接口
  bizReportType: '/ws/biz/bizReportType',
  // 业务管理-用户奖金系数接口
  bizUserBonusFactorApi: '/ws/biz/bizUserBonusFactor',
  // 业务管理-项目奖金分配接口
  bizProjectBonusApi: '/ws/biz/projectBonus',
  // 业务管理-个人薪酬接口
  bizPersonBonusApi: '/ws/biz/bizPersonBonus',
  // 收入接口
  incomeApi: '/ws/biz/bizIncome',
  // 收入拆分接口
  incomeSplitApi: '/ws/biz/bizIncomeSplit',
  // 业务来源
  busiSourceApi: '/ws/biz/bizBusinessSource',
  // 项目类型
  projectTypeApi: '/ws/biz/bizProjectType',
  // 计算公式
  reportFormulaApi: '/ws/biz/bizReportFormula',
  // 报告类型
  reportTypeApi: '/ws/biz/bizReportType',
  // 投标公告是否可用
  updateAvailable: '/ws/tender/announcement/api/updateAvailable',
  // 问题
  questionApi: '/ws/biz/bizQuestion',
  // 问题评价
  evalRecordApi: '/ws/biz/bizProjectEvalRecord',
  // 归档条目
  archiveItemApi: '/ws/biz/bizArchiveItem',
  // 核对表
  checkListApi: '/oa/report/reportReviewCheckListItem',

  // 项目单位 牌照
  findByCompany: '/ws/system/license/findByCompany',
  // 项目单位 牌照
  findProjectLicenseByCompany: '/ws/system/license/findProjectLicense',
  // 文件上传
  multipleList: '/ws/api/file/upload/multiple',
  // 消息中心
  messageApi: '/ws/biz/sysMessage',
  // 印章管理
  bizSignatureApi: '/ws/biz/bizSignature',

  /** ****************陈延start***********************/
  // 根据条件分页查询系统配置数据
  basicDataPageApi: '/ws/basic/basicData/queryPage',
  // 新增系统配置数据
  insertBasicDataApi: '/ws/basic/basicData/insert',
  // 根据ID查询系统配置数据
  basicDataByIdApi: '/ws/basic/basicData/queryOne',
  // 编辑系统配置数据
  updateBasicDataApi: '/ws/basic/basicData/update',
  // 删除系统配置数据
  deleteBasicDataApi: '/ws/basic/basicData/delete',
  // 查询启用的系统名称
  getProjectNameApi: '/ws/basic/basicData/getProjectName',
  // 根据项目类型树
  bizProjectTypeTreeApi: '/ws/biz/bizProjectType/cascaderTree',
  // 根据条件查询单位性质
  findDictDataApi: '/ws/customer/findDictData',
  // 查询母公司列表
  findParentCompanyApi: '/ws/customer/findParentCompany',
  // 查询投标公告类型列表
  getAnnouncementTypeListApi: '/ws/tender/announcement/api/getAnnouncementTypeList',
  /** ****************陈延end***********************/

  // 找回密码
  findPasswordApi: '/ws/api/forgetPassword',
  // 重置密码
  resetPasswordApi: '/ws/api/resetByForget',
  // 个人中心查看
  personalInfApi: '/ws/system/findUserByLoginName',
  // 个人中心编辑
  personalEditApi: '/ws/profile/personalCenter',
  // 个人中心修改密码
  personalPasApi: '/ws/profile/password',

  // 用户管理
  // 查询籍贯
  searchProvinceApi: '/ws/customer/getProvince',
  // 人员信息
  userSearchApi: '/ws/system/personalInfoByUserId',
  // 新增人员信息
  userAddApi: '/ws/system/personalUserAndInfo',
  // 编辑人员信息
  userEditApi: '/ws/system/personalInfo',
  // 工作经历
  workAddApi: '/ws/system/personalWorkhistory',
  // 工作经历查询列表
  workListApi: '/ws/system/personalWorkhistoryFind',
  // 教育经历
  educationAddApi: '/ws/system/personalEducation',
  // 教育经历查询列表
  educationListApi: '/ws/system/personalEducationFind',
  // 培训经历
  trainAddApi: '/ws/system/personalPersonnel',
  // 培训经历查询列表
  trainListApi: '/ws/system/personalPersonnelFind',
  // 家庭主要成员
  familyAddApi: '/ws/system/personalMainfaminly',
  // 家庭主要成员查询列表
  familyListApi: '/ws/system/personalMainfaminlyFind',
  // 职业资格
  careerAddApi: '/ws/system/personalPracticing',
  // 职业资格查询列表
  careerListApi: '/ws/system/personalPracticingFind',
  // app版本查询
  appVersionApi: '/oa/system/appVersion',
  // 获取微信绑定
  wechatBindCode: '/ws/oa/wechat/request/bind/1',
  // 微信解绑
  wechatUnBind: 'ws/oa/wechat/unbind/1',
  // 微信登录
  wechatLoginReqest: '/ws/api/wechat/request/login/1',
  //档案借阅
  bizArchive: '/oa/archive/bizArchive',
  //档案管理
  archiveManage: '/ws/biz/bizProjectArchive/manage',
  //加班申请
  overtimeApply: '/oa/administration/overtimeApply',
  //项目交接接口
  transferApi: '/ws/biz/transfer',
  //流程监控接口
  taskMonitorApi: '/ws/workflow/task/monitor',
  //考勤管理接口
  attendanceLog: '/oa/hr/attendanceLog',
  //考勤管理-假期设置
  calendar: '/oa/hr/calendar',
  //常见问题
  question: '/oa/help/question',
  // 公文管理
  documentApi: '/oa/hr/document',
  // 工时管理
  workTimeApi: '/oa/hr/workTime',
}

for (const i in oaApi) {
  api[i] = oaApi[i]
}
export default api



// WEBPACK FOOTER //
// ./src/lib/api.js